// extracted by mini-css-extract-plugin
export default {"root":"styles_root__A+I1w","container":"styles_container__qrnrA","bannerText":"styles_bannerText__PV+Dm"};